import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/common.scss' // global css
import 'animate.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import loading from './utils/loading'

import VueDeviceDetector from 'vue-device-detector';

Vue.use(VueDeviceDetector);

Vue.use(ElementUI);
Vue.config.productionTip = false


Vue.prototype.$loading = loading


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')